module.exports = __webpack_public_path__ + "img/dsci0005.ec292429.jpg";